export const PRODUCT_COPY_RU = {
  trial: {
    title: 'Попробуйте VPN',
    description: 'Бесплатный доступ без привязки карты.',
    cta: 'Получить доступ',
  },
  diagnostics: {
    title: 'Проверим подключение',
    description: 'Диагностика покажет безопасный следующий шаг без удаления профиля.',
    cta: 'Проверить подключение',
  },
  success: {
    title: 'VPN работает',
    description: 'Последнее успешное использование подтверждено сервером.',
  },
  referral: {
    eyebrow: 'Подарки друзьям',
    title: 'Подарок получите вы оба',
    cta: 'Подарить другу доступ',
  },
  review: {
    title: 'Расскажите о своём опыте',
    description: 'Публикация только с вашим согласием и после проверки.',
    cta: 'Оставить отзыв',
  },
} as const

export function referralGiftDescription(days: number): string {
  return `Друг получит ${days} дней бесплатно. После его первой покупки одинаковый бонус придёт каждому.`
}
